var React = require('react');

function Proofgrade (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.1 12.8l-7.2-4.1V.5l14.3 8.2zM7.7 21L.5 16.9V8.6l14.4 8.2z","fill":"#d3b95f","key":0}),React.createElement("path",{"d":"M29.5 8.2L15.1.1h0c-.1-.1-.2-.1-.3-.1h-.1l-.1.1h0 0L.3 8.2c-.2.1-.3.3-.3.4v8.3c0 .2.1.3.3.4l7.1 4.1 7.2 4.2c.1.1.2.1.3.1s.2 0 .2-.1l7.2-4.1c.2-.1.3-.2.3-.4v-8l6.9-4a.55.55 0 0 0 .3-.5c0-.1-.1-.3-.3-.4h0zM15 16.3l-6.2-3.5 6.1-3.5 6.2 3.5-6.1 3.5zm-.6-7.9l-6.6 3.8-2.6-1.5 9.2-5.1v2.8zm0-3.9L4.2 10.2 1.5 8.6l12.9-7.2v3.1zM1 9.5l6.5 3.7c.1 0 .1.1.1.1l6.3 3.5-6.2 3.6L1 16.6V9.5zm20.6 4.2v3.1l-10.3 5.7L8.7 21l12.9-7.3zm-6.7 10.9l-2.6-1.5 9.3-5.2v2.9l-6.7 3.8zm7.2-12.3l-6.7-3.9v-7l12.8 7.3-6.1 3.6z","fill":"#1e1f1e","key":1})]);
}

Proofgrade.defaultProps = {"width":"30","height":"26"};

module.exports = Proofgrade;

Proofgrade.default = Proofgrade;
